interface Props {
  className?: string;
  description: string;
}

export default function TableDataColumn1(props: Props) {
  const { className, description } = props;

  const getClassNames = () => {
    const defaultClasses = "font-bold text-right pr-2 italic";

    if (className) {
      return `${defaultClasses} ${className}`;
    }

    return defaultClasses;
  };

  return(
    <td className={getClassNames()}>
      {description}
    </td>
  );
}